var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 13.6875C5.5625 13.875 5.75 13.9375 6 13.9375C6.21875 13.9375 6.40625 13.875 6.5625 13.6875L15.7812 4.5C15.9062 4.375 16 4.1875 16 3.9375C16 3.71875 15.9062 3.53125 15.7812 3.375L14.625 2.25C14.4688 2.09375 14.2812 2 14.0625 2C13.8438 2 13.6562 2.09375 13.5 2.25L6 9.75L2.5 6.25C2.3125 6.09375 2.125 6 1.90625 6C1.6875 6 1.5 6.09375 1.375 6.25L0.21875 7.375C0.0625 7.53125 0 7.71875 0 7.9375C0 8.1875 0.0625 8.375 0.21875 8.5L5.4375 13.6875Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.f11f3a3f3177ef95b46c55b5824e1eaa.svg";
export { ForwardRef as ReactComponent };